import React from 'react';
import { useSelector } from 'react-redux';

function ProductBar() {
    const productDetails = useSelector((state) => state.dropTrackProducts.productDetails);

    return (
        Object.keys(productDetails).length > 0 &&
        <div className='mt-4 mx-5 border p-3 border-[#EAEAEA] rounded-lg flex gap-3 items-center select-none'>
            <div className="size-16 rounded-lg overflow-hidden">
                <img className='size-full object-cover' src={productDetails.imageUrl} alt='' />
            </div>

            <div className="flex flex-col gap-1 w-[calc(100%-64px-12px)]">
                <h1 className='font-semibold text-xl text-[#000000] w-full whitespace-nowrap overflow-hidden text-ellipsis'>
                    {productDetails.productName}
                </h1>

                <div className='font-normal text-[12px] leading-7 text-[#666666] flex items-center gap-3'>
                    <span>1 variant</span>
                    <span>₹{productDetails.productSellingPrice}</span>
                </div>
            </div>
        </div>
    );
}

export default ProductBar;
